import React from 'react';
import { Row } from 'react-bootstrap';
import SectionCard from './SectionCard';
import NoDataMessage from './NoDataMessage';

// Card with a title/action header (separated from the table by a line), a bordered table and a "no data" fallback.
// `head` is the content of <thead> (e.g. a <tr> of <th>), `children` are the <tbody> rows.
const TableSectionDataDisplayOnly = _ref => {
  let {
    title,
    action,
    header,
    head,
    children,
    isEmpty = false,
    emptyText,
    tableClassName = 'table borderless',
    bodyClassName = 'text-center'
  } = _ref;
  return /*#__PURE__*/React.createElement(SectionCard, {
    title: title,
    action: action,
    header: header
  }, isEmpty ? /*#__PURE__*/React.createElement(NoDataMessage, {
    text: emptyText
  }) : /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("table", {
    className: tableClassName
  }, /*#__PURE__*/React.createElement("thead", {
    className: "text-center"
  }, head), /*#__PURE__*/React.createElement("tbody", {
    className: bodyClassName
  }, children))));
};
export default TableSectionDataDisplayOnly;